export default "__VITE_ASSET__CJFXVPvI__"